

export const POST_GIFT_CARD_TRANSACTIONS_REQUESTED = 'giftCardAdjustment/POST_GIFT_CARD_TRANSACTIONS_REQUESTED';
export const POST_GIFT_CARD_TRANSACTIONS_SUCCESS = 'giftCardAdjustment/POST_GIFT_CARD_TRANSACTIONS_SUCCESS';
export const POST_GIFT_CARD_TRANSACTIONS_FAILURE = 'giftCardAdjustment/POST_GIFT_CARD_TRANSACTIONS_FAILURE';
export const RESET_GIFT_CARD_TRANSACTIONS = 'giftCardAdjustment/RESET_GIFT_CARD_TRANSACTIONS';
export const CHECK_CARD_STATUSES_REQUESTED = 'giftCardAdjustment/CHECK_CARD_STATUSES_REQUESTED';
export const CHECK_CARD_STATUSES_SUCCESS = 'giftCardAdjustment/CHECK_CARD_STATUSES_SUCCESS';
export const CHECK_CARD_STATUSES_FAILURE = 'giftCardAdjustment/CHECK_CARD_STATUSES_FAILURE';
export const POST_GIFT_CARD_BALANCE_INQUIRY_REQUESTED = 'giftCardAdjustment/POST_GIFT_CARD_BALANCE_INQUIRY_REQUESTED';
export const POST_GIFT_CARD_BALANCE_INQUIRY_SUCCESS = 'giftCardAdjustment/POST_GIFT_CARD_BALANCE_INQUIRY_SUCCESS';
export const POST_GIFT_CARD_BALANCE_INQUIRY_FAILURE = 'giftCardAdjustment/POST_GIFT_CARD_BALANCE_INQUIRY_FAILURE';
export const UPDATE_GIFT_CARD_NOTE_REQUESTED = 'giftCardAdjustment/UPDATE_GIFT_CARD_NOTE_REQUESTED';
export const UPDATE_GIFT_CARD_NOTE_SUCCESS = 'giftCardAdjustment/UPDATE_GIFT_CARD_NOTE_SUCCESS';
export const UPDATE_GIFT_CARD_NOTE_FAILURE = 'giftCardAdjustment/UPDATE_GIFT_CARD_NOTE_FAILURE';
export const POST_GIFT_CARD_VOID_REQUESTED = 'giftCardAdjustment/POST_GIFT_CARD_VOID_REQUESTED';
export const POST_GIFT_CARD_VOID_SUCCESS = 'giftCardAdjustment/POST_GIFT_CARD_VOID_SUCCESS';
export const POST_GIFT_CARD_VOID_FAILURE = 'giftCardAdjustment/POST_GIFT_CARD_VOID_FAILURE';
export const CLEAR_BALANCE_INQUIRY_DATA = 'giftCardAdjustment/CLEAR_BALANCE_INQUIRY_DATA';

const initialState = {
  loading: false,
  loaded: false,
  error: false,
  giftCardTransactions: [],
  cardStatusDetails: [],
  balanceInquiryData: null
};

export default(state = initialState, action) => {
  switch (action.type) {
    case POST_GIFT_CARD_TRANSACTIONS_REQUESTED: {
      return {
        ...state,
        loading: true,
        loaded: false,
      };
    }
    case POST_GIFT_CARD_TRANSACTIONS_SUCCESS: {
      return {
        ...state,
        loading: false,
        loaded: true,
        error: false,
        giftCardTransactions: action.result.transactions,
      };
    }
    case POST_GIFT_CARD_TRANSACTIONS_FAILURE: {
      return {
        ...state,
        loading: false,
        loaded: true,
        error: true,
      };
    }
    case CHECK_CARD_STATUSES_REQUESTED: {
      return {
        ...state,
        loading: true,
        loaded: false,
      };
    }
    case CHECK_CARD_STATUSES_SUCCESS: {
      return {
        ...state,
        loading: false,
        loaded: true,
        error: false,
        cardStatusDetails: action.result,
      };
    }
    case CHECK_CARD_STATUSES_FAILURE: {
      return {
        ...state,
        loading: false,
        loaded: true,
        error: true,
      };
    }

    case RESET_GIFT_CARD_TRANSACTIONS: {
      return {
        ...state,
        giftCardTransactions: []
      };
    }

    case CLEAR_BALANCE_INQUIRY_DATA: {
      return {
        ...state,
        balanceInquiryData: null
      };
    }

    case POST_GIFT_CARD_BALANCE_INQUIRY_REQUESTED: {
      return {
        ...state,
        loading: true,
        loaded: false,
      };
    }
    case POST_GIFT_CARD_BALANCE_INQUIRY_SUCCESS: {
      return {
        ...state,
        loading: false,
        loaded: true,
        error: false,
        balanceInquiryData: action.result,
      };
    }
    case POST_GIFT_CARD_BALANCE_INQUIRY_FAILURE: {
      return {
        ...state,
        loading: false,
        loaded: true,
        error: true,
      };
    }
    case UPDATE_GIFT_CARD_NOTE_REQUESTED: {
      return {
        ...state,
        loading: true,
        loaded: false,
      };
    }
    case UPDATE_GIFT_CARD_NOTE_SUCCESS: {
      return {
        ...state,
        loading: false,
        loaded: true,
        error: false,
        giftCardTransactions: state.giftCardTransactions.map(item => (item.checkCardId === action.result.checkCardId
          ? { ...item, ...action.result }
          : item)),
      };
    }
    case UPDATE_GIFT_CARD_NOTE_FAILURE: {
      return {
        ...state,
        loading: false,
        loaded: true,
        error: true,
      };
    }
    case POST_GIFT_CARD_VOID_REQUESTED: {
      return {
        ...state,
        loading: true,
        loaded: false,
      };
    }
    case POST_GIFT_CARD_VOID_SUCCESS: {
      return {
        ...state,
        loading: false,
        loaded: true,
        error: false,
        giftCardTransactions: state.giftCardTransactions.map(item => (item.checkCardId === action.result.checkCardId
          ? { ...item, ...action.result }
          : item)),
      };
    }
    case POST_GIFT_CARD_VOID_FAILURE: {
      return {
        ...state,
        loading: false,
        loaded: true,
        error: true,
      };
    }
    default: {
      return {
        ...state
      };
    }
  }
};

export const postGiftCardTransactions = (data) => {
  return {
    types: [POST_GIFT_CARD_TRANSACTIONS_REQUESTED, POST_GIFT_CARD_TRANSACTIONS_SUCCESS, POST_GIFT_CARD_TRANSACTIONS_FAILURE],
    promise: client => client.post('giftCardTransactions', { data })
  };
};

export const resetGiftCardTransactions = () => {
  return {
    type: RESET_GIFT_CARD_TRANSACTIONS,
    payload: [],
  };
};

export const checkCardStatus = () => {
  return {
    types: [CHECK_CARD_STATUSES_REQUESTED, CHECK_CARD_STATUSES_SUCCESS, CHECK_CARD_STATUSES_FAILURE],
    promise: client => client.get('checkCardStatus')
  };
};
export const postGiftCardBalanceInquiry = (data) => {
  return {
    types: [POST_GIFT_CARD_BALANCE_INQUIRY_REQUESTED, POST_GIFT_CARD_BALANCE_INQUIRY_SUCCESS, POST_GIFT_CARD_BALANCE_INQUIRY_FAILURE],
    promise: client => client.post('giftCardBalanceInquiry', { data })
  };
};
export const updateGiftCardNote = (data) => {
  return {
    types: [UPDATE_GIFT_CARD_NOTE_REQUESTED, UPDATE_GIFT_CARD_NOTE_SUCCESS, UPDATE_GIFT_CARD_NOTE_FAILURE],
    promise: client => client.post('updateGiftCardNote', { data })
  };
};

export const postGiftCardVoid = (data) => {
  return {
    types: [POST_GIFT_CARD_VOID_REQUESTED, POST_GIFT_CARD_VOID_SUCCESS, POST_GIFT_CARD_VOID_FAILURE],
    promise: client => client.post('giftCardVoid', { data })
  };
};

export const clearBalanceInquiryData = () => {
  return {
    type: CLEAR_BALANCE_INQUIRY_DATA,
    payload: [],
  };
};
